import {Contact} from "../typedefs";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";

export type ValidationError = {
    id: string;
    contact: Contact;
    errors: string[];
}

export async function fetchValidationErrors(page: number, limit: number, token: string) {
    const res = await platformAPI.get<PaginatedResponseV2<ValidationError>>("api/siren/alerts/validate-view", {
        params: { token, page, limit }
    })
    return res.data
}